import React, {ReactNode} from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Divider} from '@daedalus/atlas/Divider'
import {Grid} from '@daedalus/atlas/helpers/Grid'

interface WidgetHeaderProps {
  DatePicker: ReactNode
  GuestPicker: ReactNode
}

const HeaderWrapper = styled('div')(
  ({theme}) => css`
    background-color: ${theme.colors.background.neutral.c000};
    padding: ${theme.layout.spacing.s400}px;
  `
)

export const WidgetHeader = ({DatePicker, GuestPicker}: WidgetHeaderProps) => {
  return (
    <>
      <HeaderWrapper>
        <Grid container spacing="s300">
          <Grid mobileSm={9} desktopSm={8}>
            {DatePicker}
          </Grid>
          <Grid mobileSm={3} desktopSm={4}>
            {GuestPicker}
          </Grid>
        </Grid>
      </HeaderWrapper>
      <Divider />
    </>
  )
}
